import { render, staticRenderFns } from "./OpcionForm.vue?vue&type=template&id=14a1ee34&"
import script from "./OpcionForm.vue?vue&type=script&lang=js&"
export * from "./OpcionForm.vue?vue&type=script&lang=js&"
import style0 from "./OpcionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports